import * as FormatTypes from '../../../enums/FormatTypes.enum';
import { FormFieldInterface } from '../../../interfaces';
import { isNullOrEmptyString } from '../../../utils';
import * as gsFormattingUtility from '../../../utils/GsFormattingUtility';
import { IRowFieldValidator } from './IRowFieldValidator';
import { RowFieldBaseValidator, RowFieldValueIsValidResult } from './RowFieldBaseValidator';

export class PickListValidator extends RowFieldBaseValidator implements IRowFieldValidator {
    public validate(rowField: FormFieldInterface): RowFieldValueIsValidResult {
        let rowFieldValueIsValidResult = super.validateMandatoryProperties(rowField);
        if (rowFieldValueIsValidResult) {
            return rowFieldValueIsValidResult;
        }

        rowFieldValueIsValidResult = super.validatePrimitiveValue(rowField);

        if (!rowFieldValueIsValidResult.isValid) {
            return rowFieldValueIsValidResult;
        }

        if (rowField.validation) {
            if (isNullOrEmptyString(rowField.value)) {
                return {
                    isValid: true,
                };
            }

            const numberFormatObject = rowField.format ? gsFormattingUtility.getNumberFormatObjectAll(rowField.format, true) : undefined;
            const isPercentFormat = numberFormatObject?.numberFormat === FormatTypes.NumberFormatType.percent;

            if (isPercentFormat) {
                if (typeof rowField.value === 'string' && rowField.value.endsWith('%')) {
                    // Convert percentage string to decimal
                    const numericValue = parseFloat(rowField.value) / 100;

                    // Check if options are % strings
                    const areOptionsPercent = rowField.options?.every((opt) => {
                        return typeof opt === 'string' && opt.trim().endsWith('%') && !isNaN(parseFloat(opt));
                    });

                    const valueToCheck = areOptionsPercent ? rowField.value : numericValue;
                    return {
                        isValid: super.isPicklistOption(valueToCheck, rowField.options) || rowField.value === rowField.defaultValue,
                    };
                }
            }

            return {
                isValid: super.isPicklistOption(rowField.value, rowField.options) || rowField.value === rowField.defaultValue,
            };
        }

        return {
            isValid: true,
        };
    }
}
